module.exports = __webpack_public_path__ + "static/media/butter-robot-image-1.5331e161.jpg";